export const emptyProvider = {
  providerName: "",
  providerLogoUrl: "",
  providerLogoPath: "",
  planCount: 0,
};

export const emptyPlanPolicy = {
  id: "",
  planName: "",
  planType: "",
  policyStartingWith: "",

  addresses: [""],
  emails: [""],
  contacts: [
    {
      countryCode: "+44",
      number: "",
    },
  ],
  websites: [""],

  loaGuidelines: {
    acceptsScannedDocs: null,
    acceptsLoaByPostOnly: null,
    acceptsDigitallySignedDocs: null,
    acceptsWetSignatureOnly: null,
    acceptsLoaInsteadOfAuthority: null,
    secureEmail: null,
  },

  notes: "",
  attachmentFiles: [],
  attachments: [],
};

export const ACCEPTED_LOGO_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/svg+xml",
];

export const ACCEPTED_ATTACHMENT_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/csv",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/plain",
  "image/png",
  "image/jpeg",
  "image/jpg",
];

export const PROVIDER_NETWORK_PATH = ["ProviderNetwork", "Providers", "Data"];
